import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  Paper,
  Button,
  Box,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

interface AdditionalDocumentsProps {
  data: {
    heatPumpImage: File | null;
    cadFiles: File | null;
    performanceData: File | null;
    acousticData: File | null;
    pricingData: File | null;
    manuals: File | null;
    wiringDiagrams: File | null;
    certifications: File | null;
  };
  onChange: (field: string, value: File | null) => void;
}

const AdditionalDocumentsSection: React.FC<AdditionalDocumentsProps> = ({ data, onChange }) => {
  const handleFileChange = (field: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0] || null;
    onChange(field, file);
  };

  // List of document types
  const documentTypes = [
    { field: 'heatPumpImage', label: 'Heat pump image' },
    { field: 'cadFiles', label: 'CAD files (2D/3D models) (DWG, Solidworks, STEP, rfa/Revit)' },
    { field: 'performanceData', label: 'Performance data' },
    { field: 'acousticData', label: 'Acoustic data' },
    { field: 'pricingData', label: 'Pricing data' },
    { field: 'manuals', label: 'Manuals – usage, maintenance, installation' },
    { field: 'wiringDiagrams', label: 'Wiring diagrams' },
    { field: 'certifications', label: 'Certifications' },
  ];

  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="h5">8. Additional Documents</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Paper variant="outlined" sx={{ p: 2 }}>
          <Grid container spacing={2}>
            {documentTypes.map((docType) => (
              <Grid item xs={12} sm={6} key={docType.field}>
                <Box sx={{ border: '1px dashed #ccc', p: 2, borderRadius: 1, height: '100%' }}>
                  <Typography variant="subtitle1" gutterBottom>
                    {docType.label}
                  </Typography>
                  
                  <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                    <Button
                      component="label"
                      variant="outlined"
                      startIcon={<CloudUploadIcon />}
                      sx={{ mr: 1 }}
                    >
                      Upload
                      <input
                        type="file"
                        hidden
                        onChange={handleFileChange(docType.field)}
                      />
                    </Button>
                    
                    <Typography variant="body2" color={data[docType.field as keyof typeof data] ? 'primary' : 'text.secondary'} noWrap>
                      {data[docType.field as keyof typeof data] 
                        ? (data[docType.field as keyof typeof data] as File).name 
                        : 'No file selected'}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Paper>
      </AccordionDetails>
    </Accordion>
  );
};

export default AdditionalDocumentsSection;